// The widget's theme is fixed once rendered, so pass the app theme at render time.
export function renderCaptcha (container: string, theme: 'light' | 'dark' = 'light') {
  if (!process.env.VUE_APP_RECAPTCHA_KEY) {
    return;
  }
  grecaptcha.ready(function () {
    grecaptcha.render(container, {
      sitekey: process.env.VUE_APP_RECAPTCHA_KEY,
      theme,
    });
  });
}

export function validateCaptcha (): boolean|string {
  const captchaContainer = document.querySelector('.captcha-container');
  if (!captchaContainer) {
    return false;
  }
  captchaContainer.classList.remove('captcha-container--error');
  if (!process.env.VUE_APP_RECAPTCHA_KEY) {
    return true;
  }
  return grecaptcha.getResponse();
}

export function resetCaptcha () {
  if (!process.env.VUE_APP_RECAPTCHA_KEY) {
    return true;
  }
  grecaptcha.reset();
  return true;
}
